export default [
  {
    id: 'profile',
    label: '',
    field_name: 'profile',
    source_field: 'email_hash',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
    suppressSorting: true,
  },
  {
    id: 'calendar',
    label: '',
    field_name: 'calendar',
    source_field: 'email_hash',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
    suppressSorting: true,
  },
  {
    id: 'name',
    label: 'Name',
    field_name: 'name',
    source_field: 'name',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
  },
  {
    id: 'email',
    label: 'Email',
    field_name: 'email',
    source_field: 'email',
    showColumn: true,
    alwaysVisible: true,
    pinned: false,
  },
  {
    id: 'group_name',
    label: 'Feature Group',
    field_name: 'group_name',
    source_field: 'group_name',
    showColumn: true,
    pinned: false,
    suppressSorting: true,
  },
  {
    id: 'teaching_languages',
    label: 'Teaching Languages',
    field_name: 'teaching_languages',
    source_field: 'teaching_languages',
    showColumn: true,
    pinned: false,
  },
  {
    id: 'availability_upcoming',
    label: 'Available 2 weeks',
    field_name: 'availability_upcoming',
    source_field: 'availability_upcoming',
    showColumn: true,
    pinned: false,
  },
  {
    id: 'availability_3rd_week',
    label: 'Available 3rd Week',
    field_name: 'availability_3rd_week',
    source_field: 'availability_3rd_week',
    showColumn: true,
    pinned: false,
  },
];
